if($('.accordion').length) {
  $('.accordion').find('strong').parent('p').addClass('accordion-top').css('cursor','pointer')
  $('.accordion').find('.accordion-top').next('p').addClass('accordion-content').css('display','none')

  $(document).on('click', '.accordion .accordion-top', function () {
  	if (!$(this).hasClass('open')) {
  		$('.accordion-top').removeClass('open');
  		$('.accordion-content').slideUp(200);
  
  		$(this).addClass('open');
  		$(this).next().slideDown(200);
  	} else {
  		$('.accordion-top').removeClass('open');
  		$('.accordion-content').slideUp(200);
  	}
  })
}

$('.btn-popup-open').click(function(){
  $(this).next('.popup').show();
})
$('.close-btn').click(function(){
  $(this).parent().hide();
})